'use strict';

/* globals define, ajaxify, $, config, socket, app, utils, alerts */

define('settings-page-details', [
	'iconSelect',
	'components',
	'coverPhoto',
	'pictureCropper',
	'translator',
	'slugify',
	'bootbox',
	'alerts',
	'api'
], function (iconSelect, components, coverPhoto, pictureCropper, translator, slugify, bootbox, alerts, api) {
	var Details = {};
	var groupName;

	Details.init = function () {
		Details.initGroupSettings();

		var detailsPage = components.get('groups/container');

		groupName = ajaxify.data.group.name;

		if (ajaxify.data.group.isOwner) {
			Details.prepareSettings();

			coverPhoto.init(
				components.get('groups/cover'),
				function (imageData, position, callback) {
					socket.emit('groups.cover.update', {
						groupName: groupName,
						imageData: imageData,
						position: position,
					}, callback);
				},
				function () {
					pictureCropper.show({
						title: '[[groups:upload-group-cover]]',
						socketMethod: 'plugins.groupsSockets.uploadCover',
						aspectRatio: NaN,
						allowSkippingCrop: true,
						restrictImageDimension: false,
						paramName: 'groupName',
						paramValue: groupName,
					}, function (imageUrlOnServer) {
						imageUrlOnServer = (!imageUrlOnServer.startsWith('http') ? config.relative_path : '') + imageUrlOnServer + '?' + Date.now();
						components.get('groups/cover').css('background-image', 'url(' + imageUrlOnServer + ')');
					});
				},
				removeCover
			);
		}

		detailsPage.on('click', '[data-action]', function () {
			var btnEl = $(this);
			var action = btnEl.attr('data-action');

			switch (action) {
			case 'update':
				Details.update();
				break;

			case 'delete':
				Details.deleteGroup();
				break;
			}
		});
	};

	function getDefaultGroupColor() {
		return '#333451';
	}

	function setGroupColorToTheme(groupColor) {
		var selectors = ['#header', '#new_topic', '.groups .card-header.ch-alt'];

		$.each(selectors, function (index, value) {
			$(value).css('background-color', groupColor);
		});
	}

	Details.initGroupSettings = function () {
		require(['components'], function (components) {
			var settingsFormEl = components.get('groups/settings');
			var colorBtn = settingsFormEl.find('[data-action="group-color-select"]');
			var colorValueEl = settingsFormEl.find('[name="groupColor"]');

			colorBtn.css('background-color', colorValueEl.val() || getDefaultGroupColor());

			// Add color picker to settings form
			colorBtn.ColorPicker({
				color: colorValueEl.val() || getDefaultGroupColor(),
				onChange: function (hsb, hex) {
					colorValueEl.val('#' + hex);
					colorBtn.css('background-color', '#' + hex);

					setGroupColorToTheme('#' + hex);
				},
				onShow: function (colpkr) {
					$(colpkr).css('z-index', 1051);
				},
			});
		});
	};

	Details.prepareSettings = function () {
		var settingsFormEl = components.get('groups/settings');
		var labelColorBtn = settingsFormEl.find('[data-action="color-select"]');
		var labelColorValueEl = settingsFormEl.find('[name="labelColor"]');
		var iconBtn = settingsFormEl.find('[data-action="icon-select"]');
		var previewEl = settingsFormEl.find('.label');
		var previewIcon = previewEl.find('i');
		var userTitleEl = settingsFormEl.find('[name="userTitle"]');
		var userTitleEnabledEl = settingsFormEl.find('[name="userTitleEnabled"]');
		var iconValueEl = settingsFormEl.find('[name="icon"]');

		// Add color picker to settings form
		labelColorBtn.ColorPicker({
			color: labelColorValueEl.val() || '#000',
			onChange: function (hsb, hex) {
				labelColorValueEl.val('#' + hex);
				previewEl.css('background-color', '#' + hex);
			},
			onShow: function (colpkr) {
				$(colpkr).css('z-index', 1051);
			},
		});

		// Add icon selection interface
		iconBtn.on('click', function () {
			iconSelect.init(previewIcon, function () {
				iconValueEl.val(previewIcon.val());
			});
		});

		// If the user title changes, update that too
		userTitleEl.on('keyup', function () {
			var icon = previewIcon.detach();
			previewEl.text(' ' + (this.value || settingsFormEl.find('#name').val()));
			previewEl.prepend(icon);
		});

		// Disable user title customisation options if the the user title itself is disabled
		userTitleEnabledEl.on('change', function () {
			var customOpts = components.get('groups/userTitleOption');

			if (this.checked) {
				customOpts.removeAttr('disabled');
				previewEl.removeClass('hide');
			} else {
				customOpts.attr('disabled', 'disabled');
				previewEl.addClass('hide');
			}
		});
	};

	Details.update = function () {
		const settingsFormEl = components.get('groups/settings');
		const checkboxes = settingsFormEl.find('input[type="checkbox"][name]');

		if (settingsFormEl.length) {
			const settings = settingsFormEl.serializeObject();

			// serializeObject doesnt return array for multi selects if only one item is selected
			if (!Array.isArray(settings.memberPostCids)) {
				settings.memberPostCids = $('#memberPostCids').val();
			}

			// Fix checkbox values
			checkboxes.each(function (idx, inputEl) {
				inputEl = $(inputEl);
				if (inputEl.length) {
					settings[inputEl.attr('name')] = inputEl.prop('checked');
				}
			});
			
			api.put(`/groups/${ajaxify.data.group.slug}`, settings).then(() => {
				if (settings.name) {
					let pathname = window.location.pathname;
					pathname = pathname.substr(1, pathname.lastIndexOf('/'));
					ajaxify.go(pathname + slugify(settings.name));
				} else {
					ajaxify.refresh();
				}

				alerts.success('[[groups:event.updated]]');
			}).catch(alerts.error);
		}
	};

	Details.deleteGroup = function () {
		bootbox.confirm('Are you sure you want to delete the group: ' + utils.escapeHTML(groupName), function (confirm) {
			if (confirm) {
				bootbox.prompt('Please enter the name of this group in order to delete it:', function (response) {
					if (response === groupName) {
						api.del(`/groups/${ajaxify.data.group.slug}`, {}).then(() => {
							alerts.success('[[groups:event.deleted, ' + utils.escapeHTML(groupName) + ']]');
							ajaxify.go('groups');
						}).catch(alerts.error);
					}
				});
			}
		});
	};

	function removeCover() {
		translator.translate('[[groups:remove_group_cover_confirm]]', function (translated) {
			bootbox.confirm(translated, function (confirm) {
				if (!confirm) {
					return;
				}

				socket.emit('groups.cover.remove', {
					groupName: ajaxify.data.group.name,
				}, function (err) {
					if (!err) {
						ajaxify.refresh();
					} else {
						alerts.error(err.message);
					}
				});
			});
		});
	}

	return Details;
});
